module.exports = __webpack_public_path__ + "static/our-mission-1.84dd9287.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/our-mission-1.jpg
// module id = 522
// module chunks = 217130003604362